<template>
  <div class="card-header" :class="{'chat-box-header': inPage}">
    <span class="card-title" :class="{'chat-page': inPage}" @click="toggleCollapse(room.id)">
      <template v-if="room.type === 'single'">
        <img v-if="inPage" :src="room.user_image" class="img-thumbnail" :alt="room.user_name" />
        <span class="chat-status" :class="[getStatusClass(user.status, user.status_label), {'mx-1': inPage}]" />
        {{ user.name }}
      </template>

      <template v-if="room.type !== 'single'">
        <i v-if="inPage" class="fas fa-users mr-2"></i>
        {{ room.title }}
      </template>

      <span v-if="room.pivot.is_floating && unreadMessages > 0" class="unread-badge">
        <span class="badge badge-danger badge-pill unread-badge">
          {{ unreadMessages }}
        </span>
      </span>
    </span>

    <div class="card-header-actions">
      <template v-if="room.type !== 'single'">
        <div class="btn-group dropleft">
          <a class="" type="button" id="dropdown-group-info" data-toggle="dropdown">
            <i class="fas fa-ellipsis-v mr-2"></i>
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdown-group-info">
            <a href="#" class="dropdown-item edit-room-btn" @click="toggleChatGroupForm(room)">
              <i class="fas fa-info-circle"></i> Group Info
            </a>
            <a href="#" class="dropdown-item" @click="deleteGroupChat(room.id)">
              <i class="fas fa-trash text-danger"></i> Delete group chat
            </a>
          </div>
        </div>

      </template>
      <template v-if="room.type === 'single'">
        <a
          href="#"
          class="card-header-action video-call-coach"
          :class="{'d-inline': isInVideoCall}"
          :data-user-id="user.id"
          @click.prevent
        >
          <span class="coach-type">
            {{ userVideoCallType }}
          </span>
        </a>
        <a href="#" class="card-header-action call-coach" :data-user-id="user.id" @click.prevent>
          <span class="coach-type">
            {{ userCallType }}
          </span>
        </a>
        <a href="#" class="card-header-action make-call-from-chat" :data-user-id="user.id" @click.prevent>
          <i class="fas fa-phone-alt"></i>
        </a>
        <a :href="getVideoCallUrl(user.id)" class="card-header-action make-vide-call-from-chat" target="_blank">
          <i class="fas fa-video"></i>
        </a>
      </template>

      <template v-if="!inPage">
        <a href="#" aria-expanded="true" class="card-header-action btn-minimize" @click.prevent="toggleCollapse(room.id)">
          <i class="fas fa-minus"></i>
        </a>
        <a href="#" class="card-header-action close-chat-room" @click.prevent="$emit('close', room.id)">
          <i class="far fa-times-circle"></i>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { deleteChatRoom, getUserInCall, getUserInVideoCall } from '../../../services/api/uni-chat';
import { eventBus } from "../../../utils/helpers";
import Noty from "noty";

export default {
  name: "ConversationHeader",
  props: {
    inPage: {
      type: Boolean,
      default: false
    },
    room: {
      type: [Array, Object],
      default: []
    },
    user: {
      type: [Array, Object],
      default: []
    },
    authid: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isInCall: false,
      isInVideoCall: false,
      isChatCollapsed: false,
      userCallType: '',
      userVideoCallType: '',
      unreadMessages: 0,
    }
  },
  mounted() {
    this.isChatCollapsed = this.room.pivot.is_collapsed === 1;
    this.unreadMessages = this.room.pivot.unread;

    if (this.room.type === 'single') {
      this.getUserVideoCallCoach(this.room.id);
      this.getUserCallCoach(this.room.id);
    }

    eventBus.$on('update-unread-room', (room_id, unread) => {
      if (this.room.id === room_id) {
        this.unreadMessages = unread

        if (this.unreadMessages > 0) {
          this.notifiableMessage(room_id)
        }
      }
    });

    eventBus.$on('update-chat-room', (room) => {
      if (this.room.id === room.id) {
        this.room.title = room.title;
      }
    });
  },
  watch: {
    'room.pivot.is_collapsed': function(value) {
      this.isChatCollapsed = Boolean(value);
    }
  },
  methods: {
    getStatusClass(status, label) {
      const statusClasses = {
        'online': 'is-active',
        'visit': 'is-visit',
        'training': 'is-training',
        'lunch': 'is-lunch',
        'dnd': 'is-dnd',
        'call': 'is-call',
        'video-call': 'is-video-call',
      };

      const formattedLabel = label ? label.toLowerCase().replace(/\s+/g, '-') : null;
      const selectedStatus = status === 'busy' ? statusClasses[formattedLabel] : statusClasses[status];

      return selectedStatus || 'is-inactive';
    },
    async getUserVideoCallCoach(room_id) {
      try {
        const response = await getUserInVideoCall(room_id);

        this.isInVideoCall = response.data.status;
        this.userVideoCallType = response.data.user_type;
      } catch (error) {
        console.error('Error fetching user in video call:', error);
      }
    },
    async getUserCallCoach(room_id) {
      try {
        const response = await getUserInCall(room_id);

        this.isInCall = response.data.status;
        this.userCallType = response.data.user_type;
      } catch (error) {
        console.error('Error fetching user in call:', error);
      }
    },
    getVideoCallUrl(user_id) {
      try {
        const baseURL = window.location.origin + '/admin';
        const previewURL = '/video-calls/to/' + user_id;

        return baseURL + previewURL;
      } catch (error) {
        console.error("Error initiating video call:", error);
      }
    },
    notifiableMessage(room_id) {
      const hiddenButton = document.createElement('button');
      hiddenButton.style.display = 'none';
      hiddenButton.id = room_id;
      document.body.appendChild(hiddenButton);

      hiddenButton.addEventListener('click', () => {
        ion.sound.play("button_tiny");
      });

      hiddenButton.click(); // Simulate click
      document.body.removeChild(hiddenButton);
    },
    toggleCollapse(room_id) {
      this.isChatCollapsed = !this.isChatCollapsed;
      this.$emit('toggle', room_id, this.isChatCollapsed);
    },
    toggleChatGroupForm(room) {
      eventBus.$emit('toggle-chat-form', room);
    },
    async deleteGroupChat(room_id) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to delete this group chat?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#009f91',
        cancelButtonColor: '#df4759',
        confirmButtonText: 'Yes, delete it!',
      });

      if (result.isConfirmed) {
        try {
          const response = await deleteChatRoom({ data: { room_id } });

          if (response.status === 200) {
            new Noty({
              type: 'success',
              text: response.data.message,
              timeout: 3000
            }).show();
          } else {
            console.error('Error deleting group chat:', response.statusText);
          }
        } catch (error) {
          console.error('Error deleting group chat:', error);

          Swal.fire({
            title: 'Error!',
            text: 'TThere was an error deleting the group chat.',
            icon: 'error',
            confirmButtonColor: '#df4759'
          });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-header {
  &.chat-box-header {
    display: flex;
    border-radius: 0;
    justify-content: space-between;
    align-items: center;
    padding: 0.35rem 1.25rem;

    .card-title {
      margin-bottom: 0;

      &.chat-page {
        display: flex;
        align-items: center;

        i {
          font-size: 1.5rem;
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
        }
      }
    }

    .img-thumbnail {
      width: 40px;
      height: 40px;
      padding: 0;
      border: none;
      border-radius: 50%;
    }
  }
}
</style>